export const CLIENT_QUESTION_STATUS = {
  PENDING: 1,
  ACCEPTED: 2,
  ANSWERED: 3,
  CLOSED: 4,
  DELETED: 5,
  AWAITING: 6,
};

export const CLIENT_QUESTION_STATUS_TEXT = {
  [CLIENT_QUESTION_STATUS.PENDING]: 'Ожидает',
  [CLIENT_QUESTION_STATUS.ACCEPTED]: 'В работе',
  [CLIENT_QUESTION_STATUS.ANSWERED]: 'Отвечено',
  [CLIENT_QUESTION_STATUS.CLOSED]: 'Закрыта',
  [CLIENT_QUESTION_STATUS.DELETED]: 'Удалена',
  [CLIENT_QUESTION_STATUS.AWAITING]: 'Консультация',
};

export const PROJECT_STATUS = {
  PFDO: 1,
  EVENTS: 2,
  AFISHA: 3,
};
